module.exports = __webpack_public_path__ + "static/media/icon-selected.82ddf8e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-selected.svg
// module id = 275
// module chunks = 0